import { useState, useEffect } from "react";
import getMidwayToken from "../authentication/getMidwayToken";

export function useMidwayToken() {
  const [midwayToken, setMidwayToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchMidwayToken = async () => {
      try {
        const token = await getMidwayToken();
        setMidwayToken(token);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch midway token", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMidwayToken();
  }, []);

  return { midwayToken, isLoading };
}
